module.exports = __webpack_public_path__ + "img/portrait_night_sky_2.738a266a.jpg";